import React from 'react';

import { PageWrapper, TransparentModal } from '@order/components';
import { useTrackEventEffect } from '@order/Telemetry';

import { useNavigateBack } from '../../navigation';
import { useTransactionHistory } from './hooks';
import { SweetpassBillingHistoryScreenContent } from './SweetpassBillingHistoryScreenContent';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassBillingHistoryScreen = () => {
  const handlePressClose = useNavigateBack();

  const {
    transactionHistory = [],
    hasTransactionHistory,
    isFetching,
  } = useTransactionHistory();

  useTrackEventEffect({
    name: 'sweetpass_account.billing_history.viewed',
    skip: !hasTransactionHistory,
  });

  if (!hasTransactionHistory) return null;

  return (
    <TransparentModal size="small" onClose={handlePressClose}>
      <PageWrapper withHeaderTitle withoutFooter>
        <SweetpassBillingHistoryScreenContent
          isFetching={isFetching}
          billingHistory={transactionHistory}
        />
      </PageWrapper>
    </TransparentModal>
  );
};
